import { WorkSheetProductModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProduct'
import { connect, ConnectedProps } from 'react-redux'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { InputTableLayoutStepProps } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { ColumnOrderTableSchema } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import WorkSheetLayout from '../../../../../../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout'
import { ProductExtendedTyInputTableListing } from '../../../../../../../../../specificComponents/Product/types'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { getAllWorkSheetGroupStatuses, getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import { WorkSheetGroupStatusesPayload } from '../../../../../../../../../utils/reducers/sells/workSheetGroupStatus'
import WorkSheetProductStatusSelector from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/Inputs/WorkSheetProductStatusSelector'
import WorkSheetHeader from '../WorkSheetHeader'
import { CustomRenderString } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import SingleWorkSheetHeaderReadOnlyDecider from './SingleWorkSheetHeaderReadOnlyHeader'

type SingleWorkSheetInnerReadOnlyProps = InputTableLayoutStepProps & ReduxWorkSheetGroupStatus & {
    handleChangeView: () => void
}

interface WorkSheetProductModelTypeExtended extends WorkSheetProductModelType {
    selected: boolean
}

const SingleWorkSheetInnerReadOnly: React.FC<SingleWorkSheetInnerReadOnlyProps> = ({ tableConfiguration, setTableConfiguration, userPermissions, inputTableURLs, completeData, setCompleteData, getCompleteData, handleChangeView }) => {
    const { t } = useTwinTranslation()
    if (!completeData) {
        return null
    }
    const workSheetProductStatuses = getAllWorkSheetGroupStatuses()
    const myWorkSheetStatus = workSheetProductStatuses?.dictWorkSheetGroupStatus?.[completeData?.header?.WorkSheetGroupStatusId]?.WorkSheetProductStatusesDict || {}
    const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & WorkSheetProductModelTypeExtended> = [
        {
            id: 'nLine',
            dataKey: 'nLine',
            label: t('line', 'Línea'),
            width: 70,
        },
        {
            id: 'url',
            dataKey: 'url',
            label: t('image', 'Imagen'),
            component: 'ITDisplayImage',
            width: 70
        },
        {
            id: 'code_bar',
            dataKey: 'code_bar',
            label: t('codeBarShort', 'Cod. de barras'),
            simpleLabel: t('codeBar', 'Código de barras'),
            component: 'OrderSearchProductInput',
            field: 'code_bar',
            sortable: true,
            hideColumnByDefault: true,
            minWidth: 115
        },
        {
            id: 'referenceAndName',
            dataKey: 'name',
            label: t('referenceName', 'Referencia y nombre'),
            component: 'OrderSearchProductInputReferenceAndName',
            field: 'referenceAndName',
            minWidth: 180,
            className: 'quote_order_reference_name'
        },
        {
            id: 'WorkSheetProductStatusId',
            dataKey: 'WorkSheetProductStatusId',
            label: t('status', 'Estado'),
            customRender: (parameterValue: any, allRowData: any) => <WorkSheetProductStatusSelector workSheetProductStatuses={myWorkSheetStatus} value={parameterValue} updateDataURL={inputTableURLs.updateData} {...{ setCompleteData, allRowData, getCompleteData }} readOnly={true} />,
            width: 130,
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            component: 'ITEditableText',
            typeOnChange: 'onChangeFetch',
            readOnlyFnc: () => true
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            component: 'ITInputQuantity',
            width: 100,
            typeOnChange: 'onChangeFetch',
            sortable: true,
            applyMaxValue: true,
            readOnlyFnc: () => true
        },
        {
            id: 'unique_number',
            dataKey: 'unique_number',
            label: t('uniqueNumberShort', 'Nº único'),
            simpleLabel: t('uniqueNumber', 'Número único'),
            toolTip: t('uniqueNumber', 'Número único'),
            component: 'OrderUniqueNumberProductReadOnly',
            hideColumnByDefault: true,
        },
        {
            id: 'AssignedEmployeeId',
            dataKey: 'AssignedEmployeeId',
            label: t('employee', 'Empleado'),
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.['AssignedEmployee.fullname_short'] || ''} />,
            hideColumnByDefault: true
        },
    ]
    return (
        <WorkSheetLayout inputTableURLs={inputTableURLs} name='workSheetTable' translations={{ headerTitle: t('workSheet', 'Hoja de trabajo') }} className='workSheetTable' buttonSave={permissionCheck(getUserPermissions('sell.workSheetProductStatus'), 'read')
            ?
            <SingleWorkSheetHeaderReadOnlyDecider completeData={completeData} onSubmit={getCompleteData} getCompleteData={getCompleteData} handleChangeView={handleChangeView} />
            : undefined} InputTableHeaderChildren={WorkSheetHeader} {...{ columns, completeData, setCompleteData, getCompleteData, setTableConfiguration, tableConfiguration, userPermissions }}>
        </WorkSheetLayout>
    )
}

const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(SingleWorkSheetInnerReadOnly, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const SingleWorkSheetInnerReadOnlyConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)


export default SingleWorkSheetInnerReadOnlyConnect

